module.exports = __webpack_public_path__ + "img/close.8819ea22.svg";